const truncate = (input) => input.length > 25 ? `${input.substring(0, 25)}...` : input;
const truncateN = (input, n) => input.length > n ? `${input.substring(0, n)}...` : input;
export {truncate, truncateN}
